export interface ProtectedPlanningGeneration {
  readonly session: number;
  readonly folder: number;
  readonly folderId: string;
}

let sessionGeneration = 0;
const folderGenerations = new Map<string, number>();
const listeners = new Set<(folderId?: string) => void>();

export function subscribeProtectedPlanningInvalidation(listener: (folderId?: string) => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function captureProtectedPlanningGeneration(folderId: string): ProtectedPlanningGeneration {
  return {
    session: sessionGeneration,
    folder: folderGenerations.get(folderId) ?? 0,
    folderId,
  };
}

export function isProtectedPlanningGenerationCurrent(token: ProtectedPlanningGeneration): boolean {
  return token.session === sessionGeneration
    && token.folder === (folderGenerations.get(token.folderId) ?? 0);
}

export function invalidateProtectedPlanningFolder(folderId: string): void {
  folderGenerations.set(folderId, (folderGenerations.get(folderId) ?? 0) + 1);
  listeners.forEach((listener) => listener(folderId));
}

export function invalidateAllProtectedPlanningGenerations(): void {
  sessionGeneration += 1;
  folderGenerations.clear();
  listeners.forEach((listener) => listener());
}
